/**
 * Mobile detection helpers.
 *
 * Lives here (not in a server-only file) so both the root route's server `beforeLoad`
 * and client-side code can share the regex. The functions are pure — no runtime
 * dependencies on `window` or request helpers — so they're safe to import anywhere.
 */

/**
 * Regex matches common mobile User-Agent substrings: iPhone, iPod, Android phones,
 * Windows Phone, BlackBerry, Opera Mini. Deliberately excludes "iPad" because iPads
 * identify as desktop Safari by default since iPadOS 13, and tookii's desktop UI
 * works fine on that form factor.
 */
const MOBILE_UA_RE =
  /iPhone|iPod|Android.*Mobile|IEMobile|BlackBerry|BB10|Opera Mini|webOS|Kindle|Silk-Accelerated/i

export function isMobileUserAgent(userAgent: string | undefined | null): boolean {
  if (!userAgent) return false
  return MOBILE_UA_RE.test(userAgent)
}

/**
 * Client-side viewport check. Use inside `useEffect` or event handlers — calling it
 * during render will SSR-render as `false` on the server.
 */
export function isMobileViewport(): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia(MOBILE_VIEWPORT_QUERY).matches
}

/** Tailwind `md` breakpoint is 768px — anything below is mobile for our purposes. */
export const MOBILE_VIEWPORT_QUERY = '(max-width: 767.98px)'
